<template>
  <div style="background-color: white">
    <MarqueeTips
      v-if="false"
      :content="`当前已经注册的会员数为 ${analysis.totalCustomers} 人，今日新注册会员 ${analysis.increaseCustomers} 位.`"
      :speed="10"
    />
    <NoticeBar
      v-if="false"
      :text="`当前已经注册的会员数为 ${analysis.totalCustomers} 人，今日新注册会员 ${analysis.increaseCustomers} 位，首页浏览量 ${analysis.homeViewCount} 次.`"
      style="padding: 0"
    />
    <NoticeBar
      :text="`今日新注册会员 ${analysis.increaseCustomers} 位，首页今日浏览量 ${analysis.homeViewCount} 次.`"
      scrollable
      style="padding: 0"
    />
  </div>
</template>

<script>
import { NoticeBar } from "vant";
import MarqueeTips from "vue-marquee-tips";

export default {
  name: "Marquee",
  computed: {
    analysis() {
      return this.$store.state.analysis;
    },
  },
  components: {
    MarqueeTips,
    NoticeBar,
  },
};
</script>